._ClientFeaturesView_15r3y_1 {
  /* Empty file & class, used as a placeholder for future styling */
}